const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
const appName = process.env.REACT_APP_NAME;
// const appName = process.env.REACT_APP_NAME;
const appAlgorithmKey=process.env.REACT_APP_ALGORITHM_KEY;

export { apiBaseUrl, appName,appAlgorithmKey };

